// Formats a term in months, compactly ("9+6"), to one decimal place for averages ("7.3+6").
export const formatTerm = (
    initialTermMonths: number | null | undefined,
    contractualExtension1Months?: number | null,
    contractualExtension2Months?: number | null
): string => {
    if (initialTermMonths == null) return '';

    return [initialTermMonths, contractualExtension1Months, contractualExtension2Months]
        .filter((months): months is number => months != null)
        .map((months) => Number(months.toFixed(1)).toString())
        .join('+');
};
